import { createSelector, createStructuredSelector } from 'reselect'

export const mapStateToProps = () => {

    const mapLocalStateToProps = createStructuredSelector({

    })

    return createSelector(
        // getState,
        (_, props) => props,
        mapLocalStateToProps
    )
}
